import {
  Box,
  Button,
  Checkbox,
  IconButton,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { allRoles, userStatuses } from "../roles";
import moment from "moment";
import React, { useEffect } from "react";

import { Visibility, VisibilityOff } from "@mui/icons-material";

export const manageUsersTableCols = [
  { accessorKey: "name", header: "Name", size: 100 },
  { accessorKey: "email", header: "Email", size: 120 },
  {
    accessorKey: "initialPassword",
    header: "Initial Password",
    size: 100,
    Cell: ({ row }) => {
      const [show, setShow] = React.useState(false);
      const initialPassword = row.original.initialPassword;

      return (
        <Box display="flex" alignItems="center" gap={1}>
          <Box sx={{ flexGrow: 1 }}>{show ? initialPassword : "••••••••"}</Box>
          <Box>
            <IconButton size="small" onClick={() => setShow((prev) => !prev)}>
              {show ? <VisibilityOff /> : <Visibility />}
            </IconButton>

            <Button variant="outlined" sx={{ ml: 1 }}>
              Reset
            </Button>
          </Box>
        </Box>
      );
    },
  },
  {
    accessorKey: "roles",
    header: "Roles",
    size: 80,
    muiTableBodyCellEditTextFieldProps: {
      defaultValue: [],
    },
    // editSelectOptions: allRoles.map((r) => r.label),

    Edit: ({ cell, row, column, table }) => {
      const initialValues = Array.isArray(cell.getValue())
        ? cell.getValue()
        : [];

      const [selected, setSelected] = React.useState(initialValues);

      const handleChange = (event) => {
        const {
          target: { value },
        } = event;
        const newValue = Array.isArray(value)
          ? value
          : value
          ? value.split(",")
          : [];
        setSelected(newValue);
        // console.log("SELECTED:", newValue);
        table.options.meta?.updateData(cell.row.index, column.id, newValue);
        row._valuesCache[column.id] = newValue;
      };
      return (
        <Select
          multiple
          value={selected}
          onChange={handleChange}
          renderValue={(selected) => (
            <Box>
              {selected.map((role) => (
                <Box key={role}>- {role}</Box>
              ))}
            </Box>
          )}
          sx={{ minWidth: 200 }}
        >
          {allRoles
            .map((r) => r.label)
            .map((role) => (
              <MenuItem key={role} value={role}>
                <Checkbox checked={selected.indexOf(role) > -1} />
                <ListItemText primary={role} />
              </MenuItem>
            ))}
        </Select>
      );
    },

    Cell: ({ row }) => {
      const roles = row.original?.roles ?? [];

      return (
        <Box>
          {Array.isArray(roles) && roles.map((r) => <Box key={r}>- {r}</Box>)}
        </Box>
      );
    },
  },
  {
    accessorKey: "createdAt",
    header: "Joined At",
    size: 80,
    enableEditing: false,
    Edit: ({ cell, row, column, table }) => {
      const initialValue = cell.getValue()
        ? moment(cell.getValue()).format("YYYY-MM-DDTHH:mm")
        : moment().format("YYYY-MM-DDTHH:mm"); // default now

      const [selectedDate, setSelectedDate] = React.useState(initialValue);

      const handleChange = (e) => {
        const newValue = e.target.value;
        setSelectedDate(newValue);

        table.options.meta?.updateData(
          row.index,
          column.id,
          moment(newValue).toISOString()
        );
      };
      useEffect(() => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(today.getDate()).padStart(2, "0");

        setSelectedDate(`${year}-${month}-${day}`);
      }, []);
      return (
        <TextField
          // type="datetime-local"
          type="date"
          value={selectedDate}
          onChange={handleChange}
          variant="standard"
          label="Joined At"
          size="small"
          fullWidth
        />
      );
    },
    Cell: ({ row }) => {
      const value = row.original.createdAt;
      return value ? moment(value).fromNow() : "-";
    },
  },
  {
    accessorKey: "status",
    header: "Status",
    size: 80,
    editVariant: "select",
    editSelectOptions: userStatuses,
    Cell: ({ row }) => {
      const value = row.original.status;

      let color = "gray";

      switch (value?.toLowerCase()) {
        case "active":
          color = "green";
          break;
        case "pending":
          color = "orange";
          break;
        case "inactivated":
          color = "red";
          break;
        default:
          color = "gray";
      }

      return (
        <Box display="flex" alignItems="center">
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: color,
              marginRight: 1,
            }}
          />
          {value}
          {/* {value.charAt(0).toUpperCase() + value.slice(1)} */}
        </Box>
      );
    },
  },
];
